export default __webpack_public_path__ + "static/media/hamburger.51815719.svg";